import axios from "axios";
export default {
  props: {
    studentId: {
      type: [Number, String],
      required: true
    },
    institution: {
      type: String,
      required: true
    },
    username: {
      type: String,
      default: ""
    },
    schedule: {
      type: Object,
      default: null
    },
    defaultDate: {
      type: String,
      default: ""
    }
  },
  emits: ["close", "saved"],
  data() {
    const schedule = this.schedule || {};
    return {
      saving: false,
      timeRange: schedule.period ? schedule.period.split("-") : [],
      form: {
        title: schedule.title || "",
        date: schedule.date ? String(schedule.date).slice(0, 10) : this.defaultDate,
        scheduleContent: schedule.scheduleContent || "",
        remark: schedule.remark || ""
      }
    };
  },
  methods: {
    async save() {
      if (!this.form.title.trim() || !this.form.date || !Array.isArray(this.timeRange) || this.timeRange.length !== 2) return alert("请填写主题、日期和时间段");
      this.saving = true;
      try {
        const response = await axios.post("https://backend.wonology.com/courseArrange/studentSchedule/save", {
          id: this.schedule && this.schedule.id,
          studentId: this.studentId,
          institution: this.institution,
          username: this.username,
          ...this.form,
          title: this.form.title.trim(),
          period: this.timeRange.join("-")
        });
        if (response.data.code !== "0000") return alert(response.data.msg);
        this.$emit("saved");
      } catch (error) {
        alert("保存日程失败：" + error);
      } finally {
        this.saving = false;
      }
    },
    async remove() {
      if (!confirm(`确认删除日程“${this.schedule.title}”吗？`)) return;
      this.saving = true;
      try {
        const response = await axios.post("https://backend.wonology.com/courseArrange/studentSchedule/delete", {
          id: this.schedule.id,
          studentId: this.studentId,
          institution: this.institution
        });
        if (response.data.code !== "0000") return alert(response.data.msg);
        this.$emit("saved");
      } catch (error) {
        alert("删除日程失败：" + error);
      } finally {
        this.saving = false;
      }
    }
  }
};